import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    sorteoGlobalId: 0,
    clienteId: 0,
    cliente: '',
    sorteoGlobal: '',
    fechaSorteo: '1900-01-01',
    sorteado: false,
    tipoEventoId: 0,

    eventos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_SORTEO_GLOBAL' (state, sorteoGlobalId) {
        state.sorteoGlobalId = sorteoGlobalId;
        state.clienteId = 0;
        state.cliente = '';
        state.sorteoGlobal = '';
        state.fechaSorteo = '1900-01-01';
        state.sorteado = false;
        state.tipoEventoId = 0;
        state.eventos = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_SORTEO_GLOBAL' (state, sorteoGlobal) {
        state.clienteId = sorteoGlobal.clienteId;
        state.cliente = sorteoGlobal.cliente.trim();
        state.sorteoGlobal = sorteoGlobal.nombre.trim();
        state.fechaSorteo = moment(sorteoGlobal.fechaSorteo).format('YYYY-MM-DD HH:mm');
        state.sorteado = (/true/i).test(sorteoGlobal.sorteado);
        state.tipoEventoId = sorteoGlobal.tipoEventoId;
    },
    'SET_EVENTOS' (state, eventos) {
        state.eventos = eventos;
        state.totalRegistros = eventos.length;
    },
    // 'SET_PAGINATION'(state, params) {
    //     state.paginaActual = params.paginaActual;
    //     state.registrosPorPagina = params.registrosPorPagina;
    //     state.totalRegistros = params.totalRegistros;
    //     state.totalPaginas = params.totalPaginas;
    // },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, sorteoGlobalId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SORTEO_GLOBAL', sorteoGlobalId);

            apiAxios.get('sorteosglobales/' + sorteoGlobalId) 
            .then(res => {
                commit('SET_SORTEO_GLOBAL', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEventos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('sorteosglobales/' + state.sorteoGlobalId + '/eventos')
                .then(res => {
                    commit('SET_EVENTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addEvento ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('sorteosglobales/' + state.sorteoGlobalId + '/eventos/' + eventoId + '/add' )
                .then(res => {
                    commit('SET_EVENTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteEvento ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('sorteosglobales/' + state.sorteoGlobalId + '/eventos/' + eventoId + '/delete')
                .then(res => {
                    commit('SET_EVENTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}